import { useState, useEffect } from 'react';

interface GodAIResponse {
  epoch: number;
  tweet_url: string;
  expansion_rate: number;
}

export const useTwitterAnalysis = (epoch: number) => {
  const [tweetUrl, setTweetUrl] = useState<string>('');
  const [expansionRate, setExpansionRate] = useState<number | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      try {
        const response = await fetch(`https://god-ai-api.vercel.app/epoch/${epoch}`);
        const data: GodAIResponse = await response.json();
        
        if (data.epoch === epoch) {
          setTweetUrl(data.tweet_url);
          setExpansionRate(data.expansion_rate);
        }
      } catch (error) {
        console.error(`Error fetching data for epoch ${epoch}:`, error);
        setTweetUrl('');
        setExpansionRate(null);
      } finally {
        setLoading(false);
      }
    };

    if (epoch) {
      fetchData();
    }
  }, [epoch]);

  return { tweetUrl, expansionRate, loading };
};